/**
 * 云服务类别 产品图表页 react-grid-layout拖动层
 *
 * @format
 */

import React, { useState, useEffect, useRef } from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { gridCols, gridBreakpoints, handleGridLayouts } from '../constants'
import MonitorChartItem from './MonitorChartItem'
import { useWindowSize, useDebounce } from 'react-use'

const ResponsiveGridLayout = WidthProvider(Responsive)
const MonitorChartCollapse = ({
  productType,
  graphs,
  appId,
  rangeDate,
  instanceId,
  mointorClassValue,
  openDetails,
  recoverInitView
}) => {
  const [layouts, setLayouts] = useState({})
  const [currentLayout, setCurrentLayout] = useState([])
  const layoutConfig = useRef<{ breakpoints: string; cols: number }>({
    breakpoints: 'lg',
    cols: 12
  })

  const { width, height } = useWindowSize()

  useDebounce(
    () => {
      const layout = handleGridLayouts(graphs)
      setLayouts(layout)
    },
    200,
    [width, height]
  )

  useEffect(() => {
    const layout = handleGridLayouts(graphs)
    setLayouts(layout)
  }, [recoverInitView])

  return graphs.length > 0 ? (
    <ResponsiveGridLayout
      layouts={layouts}
      breakpoints={gridBreakpoints}
      cols={gridCols}
      onLayoutChange={layout => {
        setCurrentLayout(layout)
        setLayouts({
          ...layouts,
          [layoutConfig.current.breakpoints]: layout
        })
      }}
      onBreakpointChange={(newBreakpoint, newCols) => {
        layoutConfig.current = {
          breakpoints: newBreakpoint,
          cols: newCols
        }
      }}
    >
      {graphs.map((item, index) => {
        return (
          <div key={`${item.graphId?.toString()}-${item.title}`}>
            <MonitorChartItem
              productType={productType}
              graph={item}
              rangeDate={rangeDate}
              instanceId={instanceId}
              isRequest={mointorClassValue?.includes(appId)}
              width={currentLayout[index]?.w}
              height={currentLayout[index]?.h}
              openDetails={openDetails}
            ></MonitorChartItem>
          </div>
        )
      })}
    </ResponsiveGridLayout>
  ) : null
}
export default React.memo(MonitorChartCollapse)
